import { ButtonDownloadComponent, ButtonsActionsTableComponent } from '@app/shared';
import { EventEmitter } from '@angular/core';
import { DateFormatPipe } from '@app/shared/pipes/moment/date-format.pipe';

export class DocumentExpInventoryFormConfig {
  // se emite cada vez que se realiza una accion con los botones de la tabla
  accion: EventEmitter<any> = new EventEmitter();
  // contiene la configuracion de la tabla
  settings = {};
  // Contiene la configuracion de la modal
  settingsModal = {};
  accionModal: any;

  constructor(titleNumerber:any,titleDateNumber:any,titleExp:any,titleDateExp:any, titleDateExpExpire?:any, formData?:boolean) {
    const self = this;
    if(formData == true){
      this.settings = {
        selectMode: 'multi',
        noDataMessage: 'No hay resultados',
        actions: false,
        attr: {
          class: 'table-bordered table-hover'
        },
        columns: {
          dependencia: {
            title: 'Dependencia',
            filter: {
              inputClass: 'form-control',
            },
          },
          numero: {
            title: titleNumerber,
            filter: {
              inputClass: 'form-control',
            },
          },
          fecha: {
            title: titleDateNumber,
            filter: {
              inputClass: 'form-control',
            },
            valuePrepareFunction: (cell: any, row: any) => {
              const formatted = new DateFormatPipe().transform(row.fecha,'DD/MM/YYYY' );
              return formatted;
            }
            
          },
          fecha_vencimiento: {
            title: titleDateExpExpire,
            filter: {
              inputClass: 'form-control',
            },
            valuePrepareFunction: (cell: any, row: any) => {
              const formatted = new DateFormatPipe().transform(row.fecha_vencimiento,'DD/MM/YYYY' );
              return formatted;
            }
            
          },
          expediente: {
              title: titleExp,
              filter: {
                  inputClass: 'form-control',
                },
          },
          fecha_expediente: {
              title: titleDateExp,
              filter: {
                  inputClass: 'form-control',
                },
                valuePrepareFunction: (cell: any, row: any) => {
                  const formatted = new DateFormatPipe().transform(row.fecha_expediente,'DD/MM/YYYY' );
                  return formatted;
                }
          },
          fecha_asociacion: {
              title: 'Fecha asociacion',
              filter: {
                  inputClass: 'form-control',
                },
                valuePrepareFunction: (cell: any, row: any) => {
                  const formatted = new DateFormatPipe().transform(row.fecha_asociacion);
                  return formatted;
                }
          }
        },
      };
    }else{
      this.settings = {
        selectMode: 'multi',
        noDataMessage: 'No hay resultados',
        actions: false,
        attr: {
          class: 'table-bordered table-hover'
        },
        columns: {
          dependencia: {
            title: 'Dependencia',
            filter: {
              inputClass: 'form-control',
            },
          },
          numero: {
            title: titleNumerber,
            filter: {
              inputClass: 'form-control',
            },
          },
          fecha: {
            title: titleDateNumber,
            filter: {
              inputClass: 'form-control',
            },
            valuePrepareFunction: (cell: any, row: any) => {
              const formatted = new DateFormatPipe().transform(row.fecha,'DD/MM/YYYY' );
              return formatted;
            }
            
          },
          expediente: {
              title: titleExp,
              filter: {
                  inputClass: 'form-control',
                },
          },
          fecha_expediente: {
              title: titleDateExp,
              filter: {
                  inputClass: 'form-control',
                },
                valuePrepareFunction: (cell: any, row: any) => {
                  const formatted = new DateFormatPipe().transform(row.fecha_expediente,'DD/MM/YYYY' );
                  return formatted;
                }
          },
          fecha_asociacion: {
              title: 'Fecha asociacion',
              filter: {
                  inputClass: 'form-control',
                },
                valuePrepareFunction: (cell: any, row: any) => {
                  const formatted = new DateFormatPipe().transform(row.fecha_asociacion);
                  return formatted;
                }
          }
        },
      };
    }

    this.settingsModal = {
      selectMode: 'external',
      noDataMessage: 'No hay resultados',
      actions: false,
      attr: {
        class: 'table-bordered table-hover'
      },
      columns: {
        numero: {
          title: 'Radicado',
          filter: {
            inputClass: 'form-control',
          },
        },
        fecha: {
            title: 'Fecha',
            filter: {
                inputClass: 'form-control',
              },
              valuePrepareFunction: (cell: any, row: any) => {
                const formatted = new DateFormatPipe().transform(row.fecha,'DD/MM/YYYY' );
                return formatted;
              }
        }
      },
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/forms/all/document-exp-inventory-form/shared/document-exp-inventory-form.config.service.ts